export enum FormMakerFontFamily {
  ARIAL = 'Arial, Helvetica, sans-serif',
  ARIAL_BLACK = 'Arial Black',
  BRUSH_SCRIPT_MT = 'Brush Script MT, sans-serif',
  COMIC_SANS_MS = 'Comic Sans MS, cursive, sans-serif',
  COURIER_NEW = 'Courier New Courier, monospace',
  GEORGIA = 'Georgia, serif',
  HELVETICA = 'Helvetica, sans-serif',
  IMPACT = 'Impact, Charcoal, sans-serif',
  LUCIDA_SANS_UNICODE = 'Lucida Sans Unicode, Lucida Grande, sans-serif',
  TAHOMA = 'Tahoma, Geneva, sans-serif',
  TIMES_NEW_ROMAN = 'Times New Roman, Times, serif',
  TREBUCHET_MS = 'Trebuchet MS, Helvetica, sans-serif',
  VERDANA = 'Verdana, Geneva, sans-serif',
}

export enum FormMakerFontSize {
  PX_12 = '12px',
  PX_14 = '14px',
  PX_16 = '16px',
  PX_18 = '18px',
  PX_20 = '20px',
  PX_22 = '22px',
  PX_26 = '26px',
  PX_32 = '32px',
}
